import React, { memo } from 'react';
import Tooltip from '@clds/tooltip';

const GridTilePreviewInfo = ({ title, extension, metadata, onClick }) =>
  title ? (
    <>
      <div className="inline-flex pointer-events-all" onClick={onClick}>
        <Tooltip title={title} maxWidth="md">
          <Tooltip.OverflowTrigger>{title}</Tooltip.OverflowTrigger>
        </Tooltip>
      </div>
      <div className="flex ellipsis">
        {extension && (
          <span data-test="preview-info-file-extension" title={extension}>
            {extension}
          </span>
        )}
        {extension && metadata && <span>&nbsp;&#8226;&nbsp;</span>}
        {metadata && (
          <span data-test="preview-info-metadata" title={metadata}>
            {metadata}
          </span>
        )}
      </div>
    </>
  ) : null;

export default memo(GridTilePreviewInfo);
